<mat-card class="daxa-card new-tickets-created-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                Aperçu
            </h5>
        </mat-card-title>
        <mat-card-subtitle>
            <button type="button" mat-button class="card-header-menu-btn" [matMenuTriggerFor]="cardHeaderMenu">
                Cette Année
            </button>
            <mat-menu #cardHeaderMenu="matMenu" class="card-header-menu" xPosition="before">
                <button mat-menu-item>
                    Aujourd'hui
                </button>
                <button mat-menu-item>
                    Cette Semaine
                </button>
                <button mat-menu-item>
                    Ce Mois
                </button>
            </mat-menu>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <apx-chart
            [series]="chartOptions.series!"
            [chart]="chartOptions.chart!"
            [dataLabels]="chartOptions.dataLabels!"
            [plotOptions]="chartOptions.plotOptions!"
            [yaxis]="chartOptions.yaxis!"
            [grid]="chartOptions.grid!"
            [legend]="chartOptions.legend!"
            [fill]="chartOptions.fill!"
            [colors]="chartOptions.colors!"
            [stroke]="chartOptions.stroke!"
            [tooltip]="chartOptions.tooltip!"
            [xaxis]="chartOptions.xaxis!"
        ></apx-chart>
    </mat-card-content>
</mat-card>